<template>
    <el-drawer
        :before-close="cancel"
        :title="`${detail.name}`"
        :visible.sync="dialogVisible"
        :wrapperClosable="true"
        center
        class="dialog-container flex flex-direction"
        direction="rtl"
        size="700px">
        <div class="dialog-content flex flex-direction padding-lr-sm flex-sub">
            <div class="flex flex-direction flex-sub">
                <div class="flex align-center justify-between">
                    <div class="text-black text-df">
                        <i class="iconfont icon-vertical_line text-black text-bold text-df"></i>{{ pname }}
                    </div>
                    <div class="flex align-center">
                        <div class="text-xs margin-right-xs">优先级</div>
                        <el-tag :type="detail.level | level_color" class="tag radius">{{ detail.level | level }}
                        </el-tag>
                    </div>
                </div>
                <div v-if="detail.state === 5 || detail.state === 9" class="bg-red padding-sm radius margin-top-sm text-sm text-white">
                    拒绝原因：<span class="text-bold">{{ detail.reason }}</span>
                </div>
                <el-form class="publish-form  padding-sm radius margin-top-sm" labelWidth="auto">
                    <el-form-item label="负责人" prop="t_mid">
                        <div>{{ detail.t_mid }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="成员" prop="join_mid_str">
                        <div>{{ detail.join_mid_str }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="分值" prop="join_mid_str">
                        <div>{{ detail.is_outside ? '--' : detail.score }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="时间" prop="end_time">
                        <div>{{ detail.end_time }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="描述" prop="desc">
                        <div>{{ detail.desc || '--' }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.file.length" class="document" label="附件" prop="file">
                        <div class="flex margin-bottom-sm">
                            <div class="flex-sub flex flex-direction">
                                <div v-for="(item,index) in detail.file" :key="index" class="flex align-center">
                                    <div :href="item.url" class="file-name flex-sub ovHide text-sm" target="_blank" @click="toFilePreview(item.name,item.url)">
                                        <i class="el-icon-tickets margin-right-xs"></i>{{ item.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.folder.length" label="需求佐证" prop="file">
                        <div class="flex">
                            <div class="flex-sub flex flex-direction">
                                <div v-for="(item,index) in detail.folder" :key="index" class="flex align-center justify-between">
                                    <div class="flex-sub ovHide cursor" @click="addFile(item)">
                                        <i class="iconfont icon-24gf-folderOpen margin-right-xs"></i>{{ item.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="detail.finish_time" label="实际完成时间" prop="finish_time">
                        <div>{{ detail.finish_time }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.self_assessment_score" label="自评得分" prop="self_assessment_score">
                        <div>{{ detail.self_assessment_score }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.self_assessment" label="自评说明" prop="self_assessment">
                        <div>{{ detail.self_assessment }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                </el-form>
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="input-container  radius margin-top-sm" labelWidth="auto">
                    <el-form-item label="评审得分" prop="assessment_score">
                        <el-input-number v-model="ruleForm.assessment_score" :controls="false" :disabled="!is_task_review" :max="detail.score || 0" placeholder="请输入"></el-input-number>
                    </el-form-item>
                    <el-form-item label="评审意见" prop="assessment">
                        <el-input v-model="ruleForm.assessment" :autosize="{ minRows: 3, maxRows: 3 }"
                                  :disabled="!is_task_review" placeholder="请输入" resize="none" type="textarea">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="publish-form flex flex-direction padding-lr-sm padding-tb-xs radius margin-top-sm">
                    <div class="flex align-center justify-between">
                        <div class="text-black text-bold text-lg">任务动态</div>
                        <el-button type="text"><i class="el-icon-arrow-down text-df"></i></el-button>
                    </div>
                    <div v-for="(item,index) in detail.task_dynamic" :key="index" class="flex align-center justify-between margin-top-xs ">
                        <div class="title text-xs text-black padding-lr-sm">
                            <span>{{ item.member_name }}</span>{{ item.change_content }}
                        </div>
                        <div class="text-xs text-black">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
            <div class="foot-view"></div>
            <div v-if="is_task_review" class="foot flex align-center justify-center">
                <el-button class="btn max radius" type="danger" @click="addReasonDialog = true">驳回</el-button>
                <el-button class="btn max radius" type="success" :loading="loading" @click="submitForm('ruleForm')">通过</el-button>
            </div>
        </div>
        <task-folder-dialog :dialog-visible="addFileDialog" :fid="cur_fid" :fname="cur_fname" :pname="pname" :tname="detail.name" @watchState="watchState"></task-folder-dialog>
        <el-dialog
            :before-close="cancelReason"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`拒绝原因`"
            :visible.sync="addReasonDialog"
            append-to-body
            center
            width="400px">
            <el-form ref="ruleReasonForm" :model="ruleReasonForm" :rules="reason_rules" class="publish-form" label-width="100px">
                <el-form-item label-width="0" prop="reason">
                    <el-input v-model="ruleReasonForm.reason" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                              type="textarea">
                    </el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancelReason">取消</el-button>
                    <el-button type="primary" :loading="loading" @click="submitReasonForm('ruleReasonForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-drawer>
</template>

<script>
import {getExTaskReviewDetail, setExUpdateTaskReview} from "@/api";
import {is_task_review, level_color, levels} from "@/utils/const";
import TaskFolderDialog from "@/views/web/staff/components/TaskFolderDialog";
import {TOAST, toast, toFilePreview} from "@/utils/utils";

export default {
    name: "TaskReviewDialog",
    components: {TaskFolderDialog},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        tid: { //任务id
            type: Number,
        },
        pname: { //项目名称
            type: String,
        }
    },
    data() {
        return {
            ruleForm: {
                assessment_score: '',
                assessment: '',
            },
            detail: '',
            rules: {
                assessment_score: [
                    {required: true, message: '请输入评审得分', trigger: 'blur'}
                ],
                assessment: [
                    {required: true, message: '请输入评审意见', trigger: 'blur'}
                ],
            },
            is_task_review: true,
            cur_fname: '',
            cur_fid: 0,
            addFileDialog: false,
            ruleReasonForm: {
                reason: '',
            },
            reason_rules: {
                reason: [
                    {required: true, message: '请输入拒绝原因', trigger: 'change'}
                ]
            },
            addReasonDialog: false,
        }
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            if (this.tid) {
                let _data = await getExTaskReviewDetail(this.tid)
                _data.data.file = _data.data.file ? JSON.parse(_data.data.file) : []
                this.detail = _data.data
                this.is_task_review = is_task_review(_data.data.state)
                this.ruleForm = {
                    assessment_score: 0,
                    assessment: '',
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //state 1通过 2驳回
                    this.setTaskReview(1, '', this.ruleForm.assessment_score, this.ruleForm.assessment);
                }
            });
        },
        submitReasonForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.setTaskReview(2, this.ruleReasonForm.reason, '', '')
                }
            });
        },
        async setTaskReview(state, reason, assessment_score, assessment) {
            this.loading = true
            let _data = await setExUpdateTaskReview(this.tid, state, reason, assessment_score, assessment)
            this.loading = false
            if (_data.status === 200) {
                this.cancelReason()
                this.$emit('watchState', true)
                toast(`提交成功`, TOAST.success)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        addFile(data) {
            this.cur_fname = data.name
            this.cur_fid = data.id
            this.addFileDialog = true
        },
        watchState() {
            this.cur_fid = 0
            this.addFileDialog = false
        },
        cancelReason() {
            this.ruleReasonForm.reason = ''
            this.addReasonDialog = false
        },
        cancel() {
            this.$emit('watchState', false)
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        }
    },
    filters: {
        level(val) {
            return levels.find(f => Number(f.value) === val).label
        },
        level_color(val) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return level_color(val)
        },
    },
    watch: {
        tid() {
            this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-container {
    .publish-form {
        border: solid 1px #e6e6e6;

        .title {
            position: relative;

            &::before {
                position: absolute;
                content: '';
                width: 9px;
                height: 9px;
                border-radius: 9px;
                background-color: var(--blue);
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
}

</style>